<template>
  <div class="dual-unit-container">
    <TextField
      class="left-field"
      :unit="leftUnit"
      :value="leftValue"
      @update:value="leftValueChange"
    ></TextField>
    <span class="or-text">OR</span>
    <TextField
      class="right-field"
      :unit="rightUnit"
      :value="rightValue"
      @update:value="rightValueChange"
    ></TextField>
  </div>
</template>

<script>
import TextField from './TextField.vue'

export default {
  name: 'DualUnit',
  props: {
    rightUnit: {
      default: 'cm'
    },
    leftUnit: {
      default: 'inches'
    },
    initialValue: {
      default: NaN
    },
    leftToRightConversion: {
      default: 0.394
    }
  },
  data() {
    return {
      rightValue: 1,
      leftValue: 1
    }
  },
  components: {
    TextField
  },
  methods: {
    leftValueChange(value) {
      this.leftValue = value
      if (value === '' || isNaN(parseFloat(value))) {
        this.rightValue = ''
      } else {
        this.rightValue = Math.round(parseFloat(value) * this.leftToRightConversion)
      }
      this.$emit('valueChanged', this.leftValue, this.rightValue)
    },
    rightValueChange(value) {
      this.rightValue = value
      if (value === '' || isNaN(parseFloat(value))) {
        this.leftValue = ''
      } else {
        this.leftValue = Math.round(parseFloat(value) / this.leftToRightConversion)
      }
      this.$emit('valueChanged', this.leftValue, this.rightValue)
    }
  },
  mounted() {
    if (!isFinite(this.initialValue)) {
      this.leftValue = ''
      this.rightValue = ''
    } else {
      this.leftValue = this.initialValue
      this.rightValue = this.initialValue * this.leftToRightConversion
    }
  }
}
</script>

<style scoped>
.dual-unit-container {
  display: flex;
  flex-direction: row;
}
.left-field {
  flex: 1;
  margin-right: 1%;
  padding-right: 0.5%;
}
.right-field {
  flex: 1;
  margin-left: 1%;
  padding-right: 0.5%;
}
</style>
